module.exports = __webpack_public_path__ + "static/media/gif1.9d181748.gif";